import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'

import { STATUS_CONFIG } from '../constants'
import type { PostStationStatus } from '../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'PostStationStatusBadge',
  props: {
    status: {}
  },
  setup(__props: any) {

const props = __props;



const config = computed(() => STATUS_CONFIG[props.status])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LabelBadge, {
    label: config.value.label,
    color: config.value.color,
    icon: config.value.icon,
    size: "small"
  }, null, 8, ["label", "color", "icon"]))
}
}

})